import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";

interface IRequestCreateGuest {
    guestName: string;
    email: string;
    phoneNumber: string;
}

const GuestService = {
    create: async (data: IRequestCreateGuest) => {
        const result = await MessageClient().post(Constants.ApiPath.Guest.CREATE, data);
        return result.data.result;
    },
};

export default GuestService;
